import { isKimAndroidMobile, ua } from '@/utils/user-agent';
import { create } from 'zustand';

export type ThemeValue = 'light' | 'dark';

interface ThemeState {
  currentTheme: ThemeValue;
  initTheme: () => void;
}

// 获取系统主题偏好
const getSystemTheme = (): ThemeValue => {
  if (typeof window === 'undefined') return 'light';
  if (isKimAndroidMobile) {
    return ua.match(/(darkMode\/(1|true))/)?.[2] ? 'dark' : 'light';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

// 应用主题到 DOM
const applyTheme = (theme: ThemeValue) => {
  if (typeof document === 'undefined') return;
  if (theme === 'dark') {
    if (document.documentElement.classList.contains('kim-dark-mode')) {
      return;
    }
    document.documentElement.classList.add('kim-dark-mode');
  } else {
    if (document.documentElement.classList.contains('kim-dark-mode')) {
      document.documentElement.classList.remove('kim-dark-mode');
    }
  }
};

export const useTheme = create<ThemeState>((set, get) => ({
  currentTheme: 'light',

  initTheme: () => {
    const currentTheme = getSystemTheme();
    applyTheme(currentTheme);
    set({ currentTheme });

    // 监听系统主题变化
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => {
        const newTheme = getSystemTheme();
        applyTheme(newTheme);
        set({ currentTheme: newTheme });
      };

      mediaQuery.addListener(handleChange);

      // 返回清理函数
      return () => mediaQuery.removeListener(handleChange);
    }
  },
}));
